import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { FgpriceList } from "./fg-pricelist-entity";
import { FgPriceListController } from "./fg-pricelist-controller";
import { FgPriceListService } from "./fg-pricelist-service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";

@Module({
    imports:[
        TypeOrmModule.forFeature([FgpriceList])
    ],
    providers:[FgPriceListService,ApplicationExceptionHandler],
    controllers:[FgPriceListController],
    exports:[FgPriceListService]
})
export class FgPriceListModule{}